export const editTabsNav = {
    profile: {
        id: 'profile',
        name: 'Профиль',
        template: 'profile',
        pathName: 'doctors_edit',
    },
    specialization: {
        id: 'specialization',
        name: 'Специализация',
        template: 'schedule',
        pathName: 'doctors_edit_specialization',
    },
    schedule: {
        id: 'schedule',
        name: 'Расписание',
        template: 'schedule',
        pathName: 'doctors_edit_schedule',
    },
    duplicate: {
        id: 'duplicate',
        name: 'Дубликаты',
        template: 'schedule',
        pathName: 'doctors_edit_duplicate',
    },
};